/** @format */

import * as React from "react";
import { ButtonProps, Button } from "@mui/material";
import "./button.css";

export interface CommonButtonProps extends ButtonProps {
    children: React.ReactNode;
    ignoreButtonRootClass?: boolean;
}

const CommonButton = React.forwardRef<HTMLButtonElement, CommonButtonProps>(
    ({ children, ignoreButtonRootClass = false,  className, size, ...props }, ref) => {
        return (
            <Button
                ref={ref}
                disableElevation
                size="small"
                className={`${ignoreButtonRootClass ? "blueButton" : "button"} ${className} ${size === "small" ? "sx-custom-button" : ""}`}
                {...props}
            >
                {children}
            </Button>
        );
    }
);

export default CommonButton;
